import(/* webpackMode: "eager" */ "/codebuild/output/src4022599541/src/apps/jumplab/src/app/error.tsx");
